module.exports = __webpack_public_path__ + "static/img/home_foto2_color.c4edd5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto2_color.png
// module id = 81
// module chunks = 0